import { createGtm, useGtm } from '@gtm-support/vue-gtm'

export default defineNuxtPlugin({
  name: 'gtm',
  setup({ vueApp }) {
    const logger = useLogger('plugin:gtm')
    try {
      const { gtmId } = useRuntimeConfig().public
      if (!gtmId) {
        logger.warn('GTM is disabled')
        return
      }
      vueApp.use(createGtm({ id: gtmId, defer: true }))
      onNuxtReady(() => {
        useGtm()?.trackEvent({ event: 'optimize.activate' })
      })
    } catch (e) {
      logger.error(e)
    }
  },
})
